module.exports = __webpack_public_path__ + "img/parking_2653810.svg";